<template>
  <DsShowcase title="TelInputPlay" description="Input de telefone com seletor de país, DDI e formatação.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: string</code> — retorna o número completo com DDI</p>
      <div class="tw:max-w-lg tw:space-y-3">
        <TelInputPlay v-model="phone1" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ phone1 || '—' }}</p>
      </div>
    </section>

    <!-- PROP: defaultCountry -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">defaultCountry</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — código ISO2 do país padrão. Padrão: <code>'BR'</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <TelInputPlay v-model="phone2" default-country="US" placeholder="(000) 000-0000" />
        <TelInputPlay v-model="phone3" default-country="PT" placeholder="000 000 000" />
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'sm' | 'md' | 'lg'</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <TelInputPlay v-model="phone4" size="sm" />
        <TelInputPlay v-model="phone5" size="md" />
        <TelInputPlay v-model="phone6" size="lg" />
      </div>
    </section>

    <!-- PROP: error / disabled / skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">error / disabled / skeleton</h2>
      <div class="tw:max-w-lg tw:space-y-4">
        <TelInputPlay :error="true" placeholder="Com erro" />
        <TelInputPlay :disabled="true" model-value="+55 11999887766" />
        <TelInputPlay :skeleton="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { TelInputPlay } from '@/components/atomic'

const phone1 = ref('')
const phone2 = ref('')
const phone3 = ref('')
const phone4 = ref('')
const phone5 = ref('')
const phone6 = ref('')
</script>
